
export const errors = {
    french: {
        prefix: "Erreur",
        types: {
            err404: "Oups ! cette page ne semble pas exister"
        }
    }
}